export default {
  /**
   * @type {string} 500エラー
   */
  error500: '/500',

  error403: '/403',

  /**
   * @type {string} 404エラー
   */
  error404: '/404',
};
